import React from 'react';
import { Accordion } from './Accordion';
import { BonusAccordion } from './BonusAccordion';
import { CTAButton } from './CTAButton';
import { CountdownTimer } from './CountdownTimer';
import { PurchasePopup } from './PurchasePopup';
import { ComparisonTable } from './ComparisonTable';
import { Star, ShieldAlert, Settings, Gift, BookOpen, Crown } from 'lucide-react';
const MAIN_IMAGE = 'https://cdn.magicpatterns.com/uploads/wsZLuwesYPeEQvNj9nvaHq/ChatGPT_Image_Jun_22__2026__10_30_04_AM-removebg-preview.png';
const TOMO_IMAGES = ['https://cdn.magicpatterns.com/uploads/ny7YSz7hNZdHmBxzTNHyay/ChatGPT_Image_Jun_30,_2026,_12_25_55_PM.png', 'https://cdn.magicpatterns.com/uploads/ijVBgCWKD1VcAWwutT6FzR/ChatGPT_Image_Jun_30,_2026,_12_27_05_PM.png', 'https://cdn.magicpatterns.com/uploads/25mVuE8XMZwx2wvT4Ldhjw/ChatGPT_Image_Jun_30,_2026,_12_29_07_PM.png', 'https://cdn.magicpatterns.com/uploads/nUfz4XCWB4URCjFsEi3Usr/ChatGPT_Image_Jun_30,_2026,_12_31_10_PM.png', 'https://cdn.magicpatterns.com/uploads/4ctxyMjnm4pYJT6EbhTSEq/ChatGPT_Image_Jun_30,_2026,_12_36_02_PM.png', 'https://cdn.magicpatterns.com/uploads/qR6TtpKd8JyPjfWL1zA7oz/ChatGPT_Image_Jun_30,_2026,_12_38_49_PM.png'];
const BONUS_IMAGES = ['https://cdn.magicpatterns.com/uploads/p4H7Zs4HxVP34jX756h8qg/Screenshot_2026-06-22_at_3.57.07_PM.png', 'https://cdn.magicpatterns.com/uploads/pNkmfiKZJTMs3XXFcZ8dUo/Screenshot_2026-06-22_at_3.58.24_PM.png', 'https://cdn.magicpatterns.com/uploads/cs5mGkjsX9yXwZdxDh3Gfn/Screenshot_2026-06-22_at_3.58.47_PM.png', 'https://cdn.magicpatterns.com/uploads/ibYX58L7sP1hH2uUNCpb4P/Screenshot_2026-06-22_at_4.14.08_PM.png', 'https://cdn.magicpatterns.com/uploads/4YbNuvTv9K6VcSapbmgF48/Screenshot_2026-06-22_at_4.16.34_PM.png'];
export function SalesPage() {
  const modules = [{
    title: '📘 TOMO 1: FUNDAMENTOS DE LA ARQUERA MODERNA',
    image: TOMO_IMAGES[0],
    content: <div className="space-y-4" data-id="element-81">
          <div data-id="element-82">
            <h4 className="font-bold text-gray-800" data-id="element-83">
              Capítulo 1: El rol real de la arquera en el hockey actual
            </h4>
            <ul className="list-disc pl-5 text-sm mt-1 space-y-1" data-id="element-84">
              <li data-id="element-85">Evolución del puesto</li>
              <li data-id="element-86">Qué esperan los entrenadores modernos</li>
              <li data-id="element-87">Errores que frenan la progresión</li>
              <li data-id="element-88">Cómo evaluar tu nivel actual</li>
            </ul>
          </div>
          <div data-id="element-89">
            <h4 className="font-bold text-gray-800" data-id="element-90">
              Capítulo 2: Posición base y biomecánica
            </h4>
            <ul className="list-disc pl-5 text-sm mt-1 space-y-1" data-id="element-91">
              <li data-id="element-92">Posición lista, altura ideal y distribución del peso</li>
              <li data-id="element-93">Errores frecuentes y ajustes según distancia de tiro</li>
            </ul>
          </div>
          <div data-id="element-94">
            <h4 className="font-bold text-gray-800" data-id="element-95">
              Capítulo 3: Movimientos específicos
            </h4>
            <ul className="list-disc pl-5 text-sm mt-1 space-y-1" data-id="element-96">
              <li data-id="element-97">
                Shuffle, paso cruzado, recuperaciones y cambios de dirección
              </li>
              <li data-id="element-98">Cómo desplazarte sin perder equilibrio</li>
            </ul>
          </div>
          <div data-id="element-99">
            <h4 className="font-bold text-gray-800" data-id="element-100">
              Capítulo 4: Equipamiento
            </h4>
            <ul className="list-disc pl-5 text-sm mt-1 space-y-1" data-id="element-101">
              <li data-id="element-102">Cómo elegir casco, kickers y guantes</li>
              <li data-id="element-103">Ajustes del equipo y errores que afectan el rendimiento</li>
            </ul>
          </div>
        </div>
  }, {
    title: '🧤 TOMO 2: ATAJADAS Y RECURSOS TÉCNICOS',
    image: TOMO_IMAGES[1],
    content: <div className="space-y-4" data-id="element-104">
          <div data-id="element-105">
            <h4 className="font-bold text-gray-800" data-id="element-106">
              Capítulo 1: Bloqueos con piernas
            </h4>
            <ul className="list-disc pl-5 text-sm mt-1 space-y-1" data-id="element-107">
              <li data-id="element-108">Tiros bajos, tiros medios y rebotes</li>
            </ul>
          </div>
          <div data-id="element-109">
            <h4 className="font-bold text-gray-800" data-id="element-110">
              Capítulo 2 & 3: Uso de guantes
            </h4>
            <ul className="list-disc pl-5 text-sm mt-1 space-y-1" data-id="element-111">
              <li data-id="element-112">Guante izquierdo: Desvíos, atrapes y reacciones</li>
              <li data-id="element-113">Guante derecho: Despejes, bloqueos y coberturas</li>
            </ul>
          </div>
          <div data-id="element-114">
            <h4 className="font-bold text-gray-800" data-id="element-115">
              Capítulo 4: Recursos avanzados
            </h4>
            <ul className="list-disc pl-5 text-sm mt-1 space-y-1" data-id="element-116">
              <li data-id="element-117">
                Split save, extensiones, salidas agresivas y recursos de
                emergencia
              </li>
            </ul>
          </div>
          <div data-id="element-118">
            <h4 className="font-bold text-gray-800" data-id="element-119">
              Capítulo 5: Control de rebotes
            </h4>
            <ul className="list-disc pl-5 text-sm mt-1 space-y-1" data-id="element-120">
              <li data-id="element-121">Hacia dónde despejar, rebotes peligrosos vs seguros</li>
            </ul>
          </div>
        </div>
  }, {
    title: '🧠 TOMO 3: LECTURA DE JUEGO Y TOMA DE DECISIONES',
    image: TOMO_IMAGES[2],
    content: <div className="space-y-4" data-id="element-122">
          <div data-id="element-123">
            <h4 className="font-bold text-gray-800" data-id="element-124">
              Capítulo 1: Lectura corporal de la atacante
            </h4>
            <ul className="list-disc pl-5 text-sm mt-1 space-y-1" data-id="element-125">
              <li data-id="element-126">
                Orientación de hombros, posición del palo e indicadores previos
                al tiro
              </li>
            </ul>
          </div>
          <div data-id="element-127">
            <h4 className="font-bold text-gray-800" data-id="element-128">Capítulo 2: Ángulos</h4>
            <ul className="list-disc pl-5 text-sm mt-1 space-y-1" data-id="element-129">
              <li data-id="element-130">
                Cómo cerrar espacios, posicionamiento según ubicación de la
                bocha y ajustes dinámicos
              </li>
            </ul>
          </div>
          <div data-id="element-131">
            <h4 className="font-bold text-gray-800" data-id="element-132">
              Capítulo 3: Situaciones de partido
            </h4>
            <ul className="list-disc pl-5 text-sm mt-1 space-y-1" data-id="element-133">
              <li data-id="element-134">
                Mano a mano, dos contra una, desbordes, centros y tiros cruzados
              </li>
            </ul>
          </div>
          <div data-id="element-135">
            <h4 className="font-bold text-gray-800" data-id="element-136">
              Capítulo 4: Cuándo salir y cuándo esperar
            </h4>
            <ul className="list-disc pl-5 text-sm mt-1 space-y-1" data-id="element-137">
              <li data-id="element-138">Factores de decisión y errores más comunes</li>
            </ul>
          </div>
        </div>
  }, {
    title: '🎯 TOMO 4: CÓRNERS CORTOS Y SITUACIONES ESPECIALES',
    image: TOMO_IMAGES[3],
    content: <div className="space-y-4" data-id="element-139">
          <ul className="list-disc pl-5 text-sm space-y-2" data-id="element-140">
            <li data-id="element-141">
              <span className="font-bold" data-id="element-142">Capítulo 1:</span> La psicología del
              córner corto
            </li>
            <li data-id="element-143">
              <span className="font-bold" data-id="element-144">Capítulo 2:</span> Posicionamiento
              inicial
            </li>
            <li data-id="element-145">
              <span className="font-bold" data-id="element-146">Capítulo 3:</span> Lectura del
              arrastre
            </li>
            <li data-id="element-147">
              <span className="font-bold" data-id="element-148">Capítulo 4 & 5:</span> Desvíos y
              Rebotes
            </li>
            <li data-id="element-149">
              <span className="font-bold" data-id="element-150">Capítulo 6:</span> Variantes tácticas
              frecuentes
            </li>
            <li data-id="element-151">
              <span className="font-bold" data-id="element-152">Capítulo 7:</span> Penales
              australianos (Lectura, timing, errores frecuentes)
            </li>
          </ul>
        </div>
  }, {
    title: '🏃‍♀️ TOMO 5: ENTRENAMIENTO ESPECÍFICO DE ARQUERAS',
    image: TOMO_IMAGES[4],
    content: <div className="space-y-4" data-id="element-153">
          <ul className="list-disc pl-5 text-sm space-y-2" data-id="element-154">
            <li data-id="element-155">
              <span className="font-bold" data-id="element-156">Capítulo 1:</span> Cómo entrenar sin
              entrenador de arqueras
            </li>
            <li data-id="element-157">
              <span className="font-bold" data-id="element-158">Capítulo 2 & 3:</span> Entrenamiento
              de reflejos y velocidad lateral
            </li>
            <li data-id="element-159">
              <span className="font-bold" data-id="element-160">Capítulo 4 & 5:</span> Reacción visual
              y coordinación
            </li>
            <li data-id="element-161">
              <span className="font-bold" data-id="element-162">Capítulo 6 & 7:</span> Movilidad
              específica y potencia para arqueras
            </li>
            <li data-id="element-163">
              <span className="font-bold" data-id="element-164">Capítulo 8:</span> Prevención de
              lesiones
            </li>
          </ul>
        </div>
  }, {
    title: '🛡️ TOMO 6: FORTALEZA MENTAL Y RENDIMIENTO',
    image: TOMO_IMAGES[5],
    content: <div className="space-y-4" data-id="element-165">
          <ul className="list-disc pl-5 text-sm space-y-2" data-id="element-166">
            <li data-id="element-167">
              <span className="font-bold" data-id="element-168">Capítulo 1 & 2:</span> El miedo al
              error y cómo recuperarte después de un gol
            </li>
            <li data-id="element-169">
              <span className="font-bold" data-id="element-170">Capítulo 3:</span> Concentración
              durante todo el partido
            </li>
            <li data-id="element-171">
              <span className="font-bold" data-id="element-172">Capítulo 4 & 5:</span> Comunicación
              con la defensa y liderazgo desde el arco
            </li>
            <li data-id="element-173">
              <span className="font-bold" data-id="element-174">Capítulo 6 & 7:</span> Rutinas pre y
              post partido
            </li>
            <li data-id="element-175">
              <span className="font-bold" data-id="element-176">Capítulo 8:</span> Análisis de
              rendimiento
            </li>
          </ul>
        </div>
  }];
  const bonuses = [{
    title: '🎁 Bono 1: Atlas Visual de Situaciones de Arquera',
    image: BONUS_IMAGES[0],
    content: <div data-id="element-177">
          <p className="font-bold mb-2" data-id="element-178">Más de 100 diagramas:</p>
          <ul className="list-disc pl-5 text-sm space-y-1" data-id="element-179">
            <li data-id="element-180">Mano a mano</li>
            <li data-id="element-181">Centros</li>
            <li data-id="element-182">Desbordes</li>
            <li data-id="element-183">Córners</li>
            <li data-id="element-184">Rebotes</li>
            <li data-id="element-185">Penales</li>
          </ul>
        </div>
  }, {
    title: '🎁 Bono 2: 50 Entrenamientos Específicos',
    image: BONUS_IMAGES[1],
    content: <div data-id="element-186">
          <p className="font-bold mb-2" data-id="element-187">Clasificados por:</p>
          <ul className="list-disc pl-5 text-sm space-y-1" data-id="element-188">
            <li data-id="element-189">Reflejos</li>
            <li data-id="element-190">Técnica</li>
            <li data-id="element-191">Reacción</li>
            <li data-id="element-192">Velocidad</li>
            <li data-id="element-193">Córners</li>
          </ul>
        </div>
  }, {
    title: '🎁 Bono 3: Sistema de Autoevaluación',
    image: BONUS_IMAGES[2],
    content: <div data-id="element-194">
          <p className="font-bold mb-2" data-id="element-195">Planillas para medir:</p>
          <ul className="list-disc pl-5 text-sm space-y-1" data-id="element-196">
            <li data-id="element-197">Salidas</li>
            <li data-id="element-198">Rebotes</li>
            <li data-id="element-199">Posicionamiento</li>
            <li data-id="element-200">Comunicación</li>
            <li data-id="element-201">Córners</li>
          </ul>
        </div>
  }, {
    title: '🎁 Bono 4: Cuaderno de Partido de la Arquera',
    image: BONUS_IMAGES[3],
    content: <div data-id="element-202">
          <p className="font-bold mb-2" data-id="element-203">Registro de:</p>
          <ul className="list-disc pl-5 text-sm space-y-1" data-id="element-204">
            <li data-id="element-205">Goles recibidos</li>
            <li data-id="element-206">Errores</li>
            <li data-id="element-207">Aciertos</li>
            <li data-id="element-208">Aprendizajes</li>
            <li data-id="element-209">Objetivos</li>
          </ul>
        </div>
  }, {
    title: '🎁 Bono 5: Biblioteca de Corrección de Errores',
    image: BONUS_IMAGES[4],
    content: <div data-id="element-210">
          <p className="font-bold mb-2" data-id="element-211">Los 50 errores más comunes:</p>
          <ul className="list-disc pl-5 text-sm space-y-1" data-id="element-212">
            <li data-id="element-213">Por qué ocurren</li>
            <li data-id="element-214">Cómo corregirlos</li>
            <li data-id="element-215">Ejercicios específicos</li>
          </ul>
        </div>
  }];
  const testimonials = [{
    name: 'Martina',
    city: 'Buenos Aires',
    text: 'Siempre dudaba en los mano a mano. Desde que leí el Tomo 3, mi confianza cambió por completo. ¡Atajé 3 penales este torneo!'
  }, {
    name: 'Lucía',
    city: 'Córdoba',
    text: 'El material sobre córners cortos vale oro. Ahora sé exactamente dónde pararme y cómo leer a la arrastradora.'
  }, {
    name: 'Camila',
    city: 'Rosario',
    text: 'Entreno sola la mayor parte del tiempo. Los 50 entrenamientos específicos me salvaron la vida. Siento que mejoré muchísimo mi técnica.'
  }, {
    name: 'Sofía',
    city: 'Mendoza',
    text: 'Me costaba mucho recuperarme mentalmente después de un gol. La sección de fortaleza mental me ayudó a mantener el foco todo el partido.'
  }, {
    name: 'Valentina',
    city: 'La Plata',
    text: 'Increíble la cantidad de información detallada. Los diagramas de posición me corrigieron errores que venía arrastrando hace años.'
  }];
  const problems = ['Dudar en las salidas y quedar a mitad de camino, regalando el gol.', 'Frustración por recibir goles de rebotes mal despejados al centro del área.', 'Falta de confianza para ordenar a la defensa en los córners cortos.', 'Miedo a cometer errores que cuesten el partido y no saber cómo recuperarse mentalmente.', 'Sentir que no tenés un entrenamiento específico para mejorar tu técnica porque entrenás sola.'];
  const faqs = [{
    q: '¿Es para mi nivel?',
    a: 'Sí, el sistema está diseñado tanto para arqueras en formación (infantiles/juveniles) como para aquellas en primera división que buscan pulir detalles técnicos y tácticos.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Al realizar el pago, recibirás acceso inmediato a todos los PDFs y bonos directamente en tu correo electrónico. Podrás descargarlos al instante.'
  }, {
    q: '¿Sirve si no tengo entrenador de arqueras?',
    a: '¡Totalmente! El Tomo 5 incluye un plan completo para arqueras que entrenan solas, con rutinas y ejercicios diseñados para hacer sin ayuda.'
  }, {
    q: '¿Puedo leerlo desde el celular?',
    a: 'Sí, todos los archivos están en formato PDF optimizado para leer cómodamente en cualquier dispositivo: celular, tablet o computadora.'
  }];
  const faqItems = faqs.map(faq => ({
    title: faq.q,
    content: <p className="text-gray-600 text-sm leading-relaxed" data-id="element-216">{faq.a}</p>
  }));
  return <div className="min-h-screen bg-white font-sans text-gray-800" data-id="element-217">
      <PurchasePopup data-id="element-218" />

      {/* Header / Hero Section */}
      <header className="bg-green-50 text-gray-800 pt-12 pb-16 px-4 text-center border-b border-green-100" data-id="element-219">
        <div className="max-w-4xl mx-auto" data-id="element-220">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-black mb-6 leading-tight text-green-800 uppercase tracking-tight" data-id="element-221">
            Dejá de Regalar Goles Evitables en Cada Partido
          </h1>

          <div className="relative max-w-2xl mx-auto mb-8" data-id="element-222">
            <a href="https://checkout.ebookpoint.shop/cart/59698360811601:1" className="block cursor-pointer" data-id="element-223">
              <img src={MAIN_IMAGE} alt="Arquera de Hockey 360" className="w-[85%] h-auto mx-auto drop-shadow-2xl hover:scale-105 transition-transform duration-300" data-id="element-224" />
            </a>
          </div>

          <h2 className="text-lg md:text-xl font-medium mb-8 text-gray-600 leading-snug max-w-2xl mx-auto" data-id="element-225">
            Las 5 áreas que definen un partido —salidas, córners, pelota
            elevada, distribución y mentalidad— con su corrección paso a paso.
          </h2>

          <div className="flex flex-wrap justify-center gap-4 mb-10" data-id="element-226">
            <span className="bg-white border border-green-200 px-4 py-2 rounded-full font-bold text-sm flex items-center gap-2 text-green-800 shadow-sm" data-id="element-227">
              📄 100% PDF
            </span>
            <span className="bg-white border border-green-200 px-4 py-2 rounded-full font-bold text-sm flex items-center gap-2 text-green-800 shadow-sm" data-id="element-228">
              ⚡️ Entrega Inmediata
            </span>
            <span className="bg-white border border-green-200 px-4 py-2 rounded-full font-bold text-sm flex items-center gap-2 text-green-800 shadow-sm" data-id="element-229">
              📚 6 Módulos + 5 Bonos
            </span>
          </div>

          <CTAButton data-id="element-230" />
        </div>
      </header>

      {/* Problems Section */}
      <section className="py-16 px-4 bg-white" data-id="element-231">
        <div className="max-w-3xl mx-auto" data-id="element-232">
          <h2 className="text-3xl md:text-4xl font-black text-center mb-4 text-green-800" data-id="element-233">
            Conocemos la presión de estar debajo del arco
          </h2>
          <p className="text-center text-gray-500 mb-10 font-medium" data-id="element-234">
            ¿Te sentís identificada con alguna de estas situaciones?
          </p>

          <div className="space-y-4" data-id="element-235">
            {problems.map((problem, idx) => <div key={idx} className="flex items-start gap-4 bg-red-50 p-5 rounded-xl border border-red-200" data-id="element-236">
                <div className="bg-white p-2 rounded-full flex-shrink-0 mt-1 border border-red-200" data-id="element-237">
                  <ShieldAlert className="w-5 h-5 text-red-500" data-id="element-238" />
                </div>
                <p className="text-red-700 font-semibold leading-relaxed" data-id="element-239">
                  {problem}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Modules Section */}
      <section className="py-16 px-4 bg-green-50" data-id="element-240">
        <div className="max-w-4xl mx-auto" data-id="element-241">
          <div className="text-center mb-12" data-id="element-242">
            <h2 className="text-3xl md:text-4xl font-black text-green-800 mb-4" data-id="element-243">
              El Sistema Completo: Arquera 360
            </h2>
            <p className="text-gray-500 font-medium" data-id="element-244">
              Todo lo que necesitás saber, organizado paso a paso.
            </p>
          </div>

          <Accordion items={modules} data-id="element-245" />

          <div className="mt-12" data-id="element-246">
            <CTAButton data-id="element-247" />
          </div>
        </div>
      </section>

      {/* Testimonials (now above the bonuses) */}
      <section className="py-16 px-4 bg-white" data-id="element-248">
        <div className="max-w-5xl mx-auto" data-id="element-249">
          <h2 className="text-3xl md:text-4xl font-black text-center text-green-800 mb-12" data-id="element-250">
            Arqueras que ya transformaron su juego
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-251">
            {testimonials.map((t, idx) => <div key={idx} className="bg-green-50 p-6 rounded-2xl border border-green-100" data-id="element-252">
                <div className="flex text-amber-400 mb-4" data-id="element-253">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-254" />)}
                </div>
                <p className="text-gray-700 italic mb-6" data-id="element-255">"{t.text}"</p>
                <div className="flex items-center gap-3" data-id="element-256">
                  <div className="w-10 h-10 bg-green-200 rounded-full flex items-center justify-center text-green-800 font-bold" data-id="element-257">
                    {t.name.charAt(0)}
                  </div>
                  <div data-id="element-258">
                    <p className="font-bold text-gray-900" data-id="element-259">{t.name}</p>
                    <p className="text-xs text-gray-500" data-id="element-260">{t.city}, Argentina</p>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* Bonuses Section */}
      <section className="py-16 px-4 bg-green-50" data-id="element-261">
        <div className="max-w-4xl mx-auto" data-id="element-262">
          <div className="text-center mb-12" data-id="element-263">
            <h2 className="text-3xl md:text-4xl font-black text-green-800 mb-4" data-id="element-264">
              Bonos Exclusivos
            </h2>
            <p className="text-gray-600 font-medium text-lg" data-id="element-265">
              Llevate estos 5 complementos{' '}
              <span className="text-green-700 font-bold underline decoration-green-400 decoration-4" data-id="element-266">
                GRATIS por el día de hoy
              </span>
              .
            </p>
          </div>

          <BonusAccordion bonuses={bonuses} data-id="element-267" />
        </div>
      </section>

      {/* Comparison table — below the bonuses, above the final offer */}
      <section className="py-12 px-4 bg-white" data-id="element-268">
        <div className="max-w-3xl mx-auto" data-id="element-269">
          <h2 className="text-2xl md:text-3xl font-black text-center text-green-800 mb-6" data-id="element-270">
            La diferencia es clara
          </h2>
          <ComparisonTable data-id="element-271" />

          {/* Elite bonuses */}
          <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-272">
            {[{
            title: 'Calculadora de Proteínas e Hidratación',
            desc: 'Calculá al instante tu ingesta diaria de proteínas e hidratación según tu peso y carga de entrenamiento.'
          }, {
            title: 'Psicología Deportiva',
            desc: 'Herramientas mentales para competir con confianza, gestionar la presión y rendir bajo el arco.'
          }].map((bonus, i) => <div key={i} className="relative rounded-2xl border-2 border-green-300 bg-green-50 p-6 shadow-sm" data-id="element-273">
                <span className="inline-flex items-center gap-1 bg-green-700 text-white text-[11px] font-black uppercase tracking-wide px-3 py-1 rounded-full mb-3" data-id="element-274">
                  <Crown className="w-3.5 h-3.5" data-id="element-275" /> Bono Elite
                </span>
                <h3 className="text-lg font-black text-green-800 leading-snug" data-id="element-276">
                  {bonus.title}
                </h3>
                <p className="text-sm text-gray-600 mt-2 leading-relaxed" data-id="element-277">
                  {bonus.desc}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Final Offer — order summary to maximize perceived value */}
      <section className="py-16 px-4 bg-green-50" data-id="element-278">
        <div className="max-w-2xl mx-auto" data-id="element-279">
          <h2 className="text-3xl md:text-4xl font-black text-center text-green-800 mb-2" data-id="element-280">
            Esto es todo lo que te llevás hoy
          </h2>
          <p className="text-center text-gray-500 font-medium mb-6" data-id="element-281">
            Un sistema completo por una fracción de su valor real.
          </p>

          <CountdownTimer data-id="element-282" />

          <div className="bg-white border-2 border-green-300 rounded-2xl p-5 md:p-6 shadow-lg mt-6" data-id="element-283">
            {/* Summary list */}
            <ul className="divide-y divide-green-100" data-id="element-284">
              {[{
              icon: BookOpen,
              label: '6 Tomos en PDF',
              value: '$54.900'
            }, {
              icon: Gift,
              label: 'Bono 1 – Atlas Visual',
              value: 'GRATIS',
              free: true
            }, {
              icon: Gift,
              label: 'Bono 2 – 50 Entrenamientos',
              value: 'GRATIS',
              free: true
            }, {
              icon: Gift,
              label: 'Bono 3 – Autoevaluación',
              value: 'GRATIS',
              free: true
            }, {
              icon: Gift,
              label: 'Bono 4 – Cuaderno de Partido',
              value: 'GRATIS',
              free: true
            }, {
              icon: Gift,
              label: 'Bono 5 – Corrección de Errores',
              value: 'GRATIS',
              free: true
            }, {
              icon: Crown,
              label: 'Bono Elite – Proteínas e Hidratación',
              value: 'GRATIS',
              free: true
            }, {
              icon: Crown,
              label: 'Bono Elite – Psicología Deportiva',
              value: 'GRATIS',
              free: true
            }].map((row, i) => {
              const Icon = row.icon;
              return <li key={i} className="flex items-center justify-between gap-3 py-2" data-id="element-285">
                    <span className="flex items-center gap-2.5 text-sm text-gray-700" data-id="element-286">
                      <Icon className={`w-4 h-4 flex-shrink-0 ${row.free ? 'text-green-600' : 'text-gray-400'}`} data-id="element-287" />
                      {row.label}
                    </span>
                    <span className={`text-sm font-bold flex-shrink-0 ${row.free ? 'text-green-600' : 'text-gray-400 line-through'}`} data-id="element-288">
                      {row.value}
                    </span>
                  </li>;
            })}
            </ul>

            {/* Price + buy button */}
            <div className="mt-4 pt-4 border-t border-green-200" data-id="element-289">
              <CTAButton showPrice={true} data-id="element-290" />
            </div>
          </div>
        </div>
      </section>

      {/* FAQ — collapsible */}
      <section className="py-16 px-4 bg-green-50" data-id="element-291">
        <div className="max-w-3xl mx-auto" data-id="element-292">
          <h2 className="text-3xl font-black text-center text-green-800 mb-10" data-id="element-293">
            Preguntas Frecuentes
          </h2>
          <Accordion items={faqItems} data-id="element-294" />
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-green-800 text-green-100 py-12 text-center" data-id="element-295">
        <div className="flex items-center justify-center gap-2 mb-4" data-id="element-296">
          <Settings className="w-5 h-5" data-id="element-297" />
          <span className="font-medium" data-id="element-298">Soporte: EbookDreamShop@gmail.com</span>
        </div>
        <p className="text-sm mt-4 text-green-200" data-id="element-299">
          © {new Date().getFullYear()} Arquera de Hockey 360. Todos los
          derechos reservados.
        </p>
        <p className="text-xs mt-2 max-w-2xl mx-auto px-4 text-green-300/70" data-id="element-300">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
      </footer>
    </div>;
}